
<template>
	<div class="crediLimit">
		<div class="container1">
			<div class="top-container">
				<div class="creditRate-box">
					<div class="creditRate">
						<div class="title">信用</div>
						<div class="rate">{{creditStatus}}</div>
					</div>
					<el-progress type="circle" :percentage="creditRate*100" :stroke-width="15" :show-text="false" :color="progressStatusColor"></el-progress>
				</div>
				<div class="limit-item">
					<div class="fx-title">
						信用额度
						<el-tooltip effect="dark" placement="top" popper-class="tip-class">
							<div slot="content">信用额度是卖家在后台设置的买家可以在未支付下，<br/><br/>可下单的额度数值。</div>
							<div class="tip-icon">
								<img src="~/images/icon/tooltip-icon.png" width="14" height="14">
							</div>
						</el-tooltip>
					</div>
					<div class="money">
						{{creditlimit}}<span>元</span>
					</div>
				</div>
				<div class="limit-item">
					<div class="fx-title">
						已用信用额度
						<el-tooltip effect="dark" placement="top" popper-class="tip-class">
							<div slot="content">已使用信用余额是使用信用额度下单，<br/><br/>但是未支付订单的金额合计。</div>
							<div class="tip-icon">
								<img src="~/images/icon/tooltip-icon.png" width="14" height="14">
							</div>
						</el-tooltip>
					</div>
					<div class="money">
						{{usedlimit}}<span>元</span>
					</div>
					<div class="search-order">
						<span @click="searchOrder" style="margin-right:10px">查看单据</span><span @click="creditRefresh">刷新</span>
					</div>
				</div>
				<div class="limit-item">
					<div class="fx-title">
						可用信用额度
						<el-tooltip effect="dark" placement="top" popper-class="tip-class">
							<div slot="content">1、可用信用余额=信用额度-已使用余额<br/><br/>2、支持买家在不支付订单下可提单的金额</div>
							<div class="tip-icon">
								<img src="~/images/icon/tooltip-icon.png" width="14" height="14">
							</div>
						</el-tooltip>
					</div>
					<div class="money">
						{{canuselimit}}<span>元</span>
					</div>
				</div>
			</div>
			<div class="form-container">
				<el-form
					:model="ruleForm"
					:rules="rules"
					ref="ruleForm"
					label-position='right'
					label-width="150px"
				>
					<el-form-item label="信用额度：" prop="creditlimit">
						<el-col :span="3">
							<el-input size="mini" v-model="ruleForm.creditlimit" placeholder="请输入信用额度" @input="checkNum(ruleForm.creditlimit)" type="number"></el-input>
						</el-col>
					</el-form-item>
					<el-form-item label="已用信用额度：" prop="usedlimit">
						<el-col :span="3">
							<el-input size="mini" v-model="ruleForm.usedlimit" :maxlength="10" disabled></el-input>
						</el-col>
					</el-form-item>
					<el-form-item label="可用信用额度：" prop="canuselimit">
						<el-col :span="3">
							<el-input size="mini" v-model="ruleForm.canuselimit" :maxlength="10" disabled></el-input>
						</el-col>
					</el-form-item>
					<el-form-item>
						<el-col :span="4">
							<div class="tips" style="text-align: left;font-size: 12px;color: #666666">= 信用额度 - 已用信用额度</div>
						</el-col>
					</el-form-item>
					<el-form-item label="使用信用额度下单：" prop="userLimitFlag">
						<el-col :span="4" class="col">
							<el-radio v-model="ruleForm.userLimitFlag" :label="1" :disabled="prepaymentdefaultaccount && matchbillcenterflag">允许</el-radio>
							<el-radio v-model="ruleForm.userLimitFlag" :label="0">不允许</el-radio>
							<el-tooltip effect="dark" placement="top" popper-class="tip-class">
								<div slot="content"> * 该功能允许使用后在预付货款可用余额不足，<br/>
								<br/>或者后付款场景下才可以使用信用额度下单。<br/>
								<br/>* 如客户的预付货款为非本系统，则信用额度不允许使用。</div>
								<span class="tip-icon">
									<img src="~/images/icon/tooltip-icon.png" width="14" height="14" style="display:inline-block;">
								</span>
							</el-tooltip>
						</el-col>
					</el-form-item>
					<el-form-item label="客户查看信用额度：" prop="searchLimitFlag">
						<el-col :span="4" class="col">
							<el-radio v-model="ruleForm.searchLimitFlag" :label="1">允许</el-radio>
							<el-radio v-model="ruleForm.searchLimitFlag" :label="0">不允许</el-radio>
							<el-tooltip effect="dark" placement="top" popper-class="tip-class">
								<div slot="content"> * 买家下单的时候可查看信用额度、<br/><br/>可用信用额度后根据实际情况使用信用额度。</div>
								<span class="tip-icon">
									<img src="~/images/icon/tooltip-icon.png" width="14" height="14" style="display:inline-block;">
								</span>
							</el-tooltip>
						</el-col>
					</el-form-item>
					<el-form-item label="附件：" prop="searchLimitFlag">
						<el-col :span="12" class="col">
							<ShowImg :imgInfo='imgInfo' ref="showImgRef"/>
						</el-col>
					</el-form-item>
				</el-form>
			</div>
			<el-dialog title="信用额度使用明细" class="confirm-dialog" top='60px' @close="cancelDialog" :visible.sync="dialogFlag" width='1025px' :close-on-click-modal="false">
				<div class="dialog-container">
					<div style="text-align: left;margin: -5px 0 10px 0;">以下订单使用信用额度，但未支付单据：</div>
					<el-table
						:data="tableData"
						:header-cell-style="{background:'#F7F8FA', color:'#333333', fontSize:'14px', fontWeight:'bold'}"
						:height="tableHeight">
						<el-table-column
							label="序号"
							type="index"
							width="50"
							align="center">
						</el-table-column>
						<el-table-column
							prop="ordernumber"
							label="订单编号"
							align="center">
						</el-table-column>
						<el-table-column
							prop="money"
							label="订单占用信用额度"
							align="center">
							<template slot-scope="scope">
								{{$fxUtils.toFixedSHW(scope.row.money, 2)}}
							</template>
						</el-table-column>
						<el-table-column
							prop="billState"
							label="订单状态"
							align="center">
						</el-table-column>
						<el-table-column
							label="操作"
							align="center">
							<template slot-scope="scope">
								<el-button size="mini" type="text" @click="search(scope.row)">查看</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="button-box">
					<el-button type="primary" class="freigh-button" @click="cancelDialog">关闭</el-button>
				</div>
			</el-dialog>
		</div>
		<div class="foot">
			<el-button class="btn" size="mini" type="primary" v-if="AuthorityList['03_0001_0014_00']" @click='saveClick()'>保存</el-button>
		</div>
	</div>
</template>
<script>
import ShowImg from '@/views/index/src/customer/src//ShowImg.vue'
export default {
	name: 'creditLimit',
	components: {
		ShowImg
	},
	data () {
		return {
			tableHeight: '100%',
			creditRate: 1,
			creditStatus: '',
			progressStatusColor: '#E3E6E8',
			ruleForm: {
				creditlimit: '',
				usedlimit: '',
				canuselimit: '',
				userLimitFlag: 0,
				searchLimitFlag: 0
			},
			creditlimit: '',
			usedlimit: '',
			canuselimit: '',
			rules: {
				creditlimit: [
					{ required: true, message: '请填写信用额度', trigger: 'blur' }
				]
			},
			customerid: '',
			dialogFlag: false,
			tableData: [],
			orderParams: {},
			tabParams: {},
			AuthorityList: {
				'07_0001_0001_00': false,
				'07_0001_0002_00': false,
				'07_0001_0003_00': false,
				'07_0001_0004_00': false,
				'07_0001_0005_00': false,
				'07_0001_0006_00': false,
				'07_0001_0007_00': false,
				'07_0001_0008_00': false,
				'07_0001_0009_00': false,
				'07_0001_0010_00': false,
				'07_0001_0011_00': false,
				'07_0001_0012_00': false,
				'07_0001_0013_00': false,
				'07_0001_0014_00': false,
				'07_0001_0015_00': false,
				'07_0001_0016_00': false,
				'07_0001_0017_00': false,
				'07_0001_0018_00': false,
				'07_0001_0019_00': false,
				'07_0001_0020_00': false,
				'07_0001_0021_00': false,
				'07_0001_0022_00': false,
				'07_0001_0025_00': false,
				'07_0001_0026_00': false,
				'07_0001_0027_00': false,
				'03_0001_0014_00': false
			},
			imgInfo: [],
			flag: false,
			fxDataVerification: this.$fxUtils.fxDataVerification(),
			prepaymentdefaultaccount: 0,
			matchbillcenterflag: 0
		}
	},
	created () {
		this.customerid = window.sessionStorage.getItem('customerid')
		this.checkSmallCategory()
		this.getAuthority('07_0001_0000_00')
		this.getAuthority('03_0001_0000_00')
		this.getDetail()
	},
	methods: {
		checkSmallCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.prepaymentdefaultaccount = res.prepaymentdefaultaccount
				this.matchbillcenterflag = res.matchbillcenterflag
			})
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		checkNum (value) {
			this.ruleForm.creditlimit = value.replace(/[^\d.]/g, '')
			this.ruleForm.creditlimit = value.replace(/^\./g, '')
			this.ruleForm.creditlimit = value.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.ruleForm.creditlimit = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			this.ruleForm.creditlimit = value.replace(/^(\-)*(\d*)\.(\d\d).*$/, '$1$2.$3')
			this.ruleForm.creditlimit = value.indexOf('.') > 0 ? value.split('.')[0].substring(0, 7) + '.' + value.split('.')[1].substring(0, 2) : value.substring(0, 7)
		},
		getDetail () {
			let params = {
				id: this.customerid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/creditline/detail`,
				data: params
			}).then(res => {
				if (res.result) {
					this.imgInfo = res.data.imgList
					if (res.data.creditline) {
						this.creditRate = res.data.usablecreditline / res.data.creditline
						if (this.creditRate > 0.1) {
							this.flag = true
						} else {
							this.flag = false
							this.creditRate = 1 - (res.data.usablecreditline / res.data.creditline)
						}
					} else {
						this.flag = false
						this.creditRate = 1
					}
					this.creditlimit = this.$fxUtils.toFixedSHW(res.data.creditline, 2)
					this.usedlimit = this.$fxUtils.toFixedSHW(res.data.usedcreditline, 2)
					this.canuselimit = this.$fxUtils.toFixedSHW(res.data.usablecreditline, 2)
					this.ruleForm.creditlimit = this.$fxUtils.toFixedSHW(res.data.creditline, 2)
					this.ruleForm.usedlimit = this.$fxUtils.toFixedSHW(res.data.usedcreditline, 2)
					this.ruleForm.canuselimit = this.$fxUtils.toFixedSHW(res.data.usablecreditline, 2)
					this.ruleForm.userLimitFlag = res.data.creditlineflag ? 1 : 0
					this.ruleForm.searchLimitFlag = res.data.lookcreditlineflag ? 1 : 0
					if (this.ruleForm.userLimitFlag) {
						if (this.flag) {
							this.creditStatus = '良好'
							this.progressStatusColor = '#1DC230'
						} else {
							this.creditStatus = '预警'
							this.progressStatusColor = '#FA2E2E'
						}
					} else {
						this.creditStatus = '未使用'
						this.progressStatusColor = '#E3E6E8'
					}
					this.fxDataVerification.resetData(this.ruleForm)
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		searchOrder () {
			this.dialogFlag = true
			let params = {
				id: this.customerid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/creditline/orderlist`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tableData = res.data
					this.tableData.forEach(item => {
						switch (item.billState) {
						case 0:
							item.billState = '待付款'
							break
						case 1:
							item.billState = '待接单'
							break
						case 2:
							item.billState = '待发货'
							break
						case 3:
							item.billState = '待收货'
							break
						case 4:
							item.billState = '已完成'
							break
						case 5:
							item.billState = '备货中'
							break
						case 6:
							item.billState = '财务审核'
							break
						}
					})
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		creditRefresh () {
			let params = {
				id: this.customerid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/creditline/refresh`,
				data: params
			}).then(res => {
				if (res.result) {
					if (res.data.creditline) {
						this.creditRate = res.data.usablecreditline / res.data.creditline
						if (this.creditRate > 0.1) {
							this.flag = true
						} else {
							this.flag = false
							this.creditRate = 1 - (res.data.usablecreditline / res.data.creditline)
						}
					} else {
						this.flag = false
						this.creditRate = 1
					}
					this.creditlimit = this.$fxUtils.toFixedSHW(res.data.creditline, 2)
					this.usedlimit = this.$fxUtils.toFixedSHW(res.data.usedcreditline, 2)
					this.canuselimit = this.$fxUtils.toFixedSHW(res.data.usablecreditline, 2)
					this.ruleForm.creditlimit = this.$fxUtils.toFixedSHW(res.data.creditline, 2)
					this.ruleForm.usedlimit = this.$fxUtils.toFixedSHW(res.data.usedcreditline, 2)
					this.ruleForm.canuselimit = this.$fxUtils.toFixedSHW(res.data.usablecreditline, 2)
					if (this.ruleForm.userLimitFlag) {
						if (this.flag) {
							this.creditStatus = '良好'
							this.progressStatusColor = '#1DC230'
						} else {
							this.creditStatus = '预警'
							this.progressStatusColor = '#FA2E2E'
						}
					} else {
						this.creditStatus = '未使用'
						this.progressStatusColor = '#E3E6E8'
					}
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		cancelDialog () {
			this.dialogFlag = false
		},
		search (value) {
			if ((value.billState === '财务审核' && (this.AuthorityList['07_0001_0026_00'] || this.AuthorityList['07_0001_0027_00'])) || (value.billState === '待付款' && (this.AuthorityList['07_0001_0002_00'] || this.AuthorityList['07_0001_0003_00'])) || (value.billState === '待接单' && (this.AuthorityList['07_0001_0005_00'] || this.AuthorityList['07_0001_0006_00'])) || (value.billState === '待发货' && (this.AuthorityList['07_0001_0008_00'] || this.AuthorityList['07_0001_0009_00'])) || (value.billState === '备货中' && value.sellpullstate === 1 && (this.AuthorityList['07_0001_0011_00'] || this.AuthorityList['07_0001_0012_00'])) || (value.billState === '待收货' && (this.AuthorityList['07_0001_0014_00'] || this.AuthorityList['07_0001_0015_00'])) || (value.billState === '已完成' && (this.AuthorityList['07_0001_0017_00'] || this.AuthorityList['07_0001_0018_00'])) || (value.billState === '已取消' && (this.AuthorityList['07_0001_0020_00'] || this.AuthorityList['07_0001_0021_00']))) {
			} else {
				this.$message.error('您没有查看此订单权限！')
				return false
			}
			this.orderParams.orderId = value.orderid
			this.orderParams.statusId = value.statusId
			this.orderParams.billState = value.billState
			this.orderParams.differ = '0'
			this.tabParams.isSellerpull = false
			this.tabParams.orderStatus = +value.orderstatus
			this.tabParams.active = value.billState
			let orderParams = JSON.stringify(this.orderParams)
			let tabInfo = JSON.stringify(this.tabParams)
			window.sessionStorage.setItem('orderInfo', orderParams)
			window.sessionStorage.setItem('tabInfo', tabInfo)
			this.$router.push('/main/orderDetail')
		},
		saveClick () {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					let showImgRef = this.$refs.showImgRef
					showImgRef.showSrc.forEach((item, index) => {
						item.defaultflag = index === 0 ? 1 : 0
						item.seqnum = '' + (index + 1)
					})
					let params = {
						id: this.customerid,
						creditline: +this.ruleForm.creditlimit,
						creditlineflag: this.ruleForm.userLimitFlag,
						lookcreditlineflag: this.ruleForm.searchLimitFlag,
						imgList: showImgRef.showSrc
					}
					const logger = this.$fxLogger.createInfo('custom.custom-credit.update', this.createLoggerParams())
					this.$store.dispatch('requestPost', {
						url: `${this.$fxBaseApi.urlQIVShop}/customer/creditline/update`,
						data: params,
						logger
					}).then(res => {
						if (res.result) {
							this.$message.success('保存成功！')
							this.getDetail()
						} else {
							this.$message.error(res.msg)
						}
					}).catch(err => {
						this.$message.error(err.msg)
					})
				} else {
					return false
				}
			})
		},
		createLoggerParams () {
			const originData = this.fxDataVerification.getOriginData()
			const ruleForm = this.$fxUtils.deepClone(this.ruleForm)
			return {
				pre: originData,
				cur: ruleForm,
				name: window.sessionStorage.getItem('customerName')
			}
		}
	}
}
</script>
<style lang="stylus" scoped>
.crediLimit{
		height: calc(100% - 140px)
    width: 100%;
	.container1{
		width: 100%
		flex-direction: column !important
		height: calc(100% - 50px);
		overflow-x: hidden;
		overflow-y: auto;
		margin-bottom: 20px;
		padding-bottom: 30px;
		border-radius: 0px 0px 10px 10px;
		padding-left: 20px;
		.top-container {
			position: relative
			width: 100%
			display: flex
			align-items: center
			justify-content: start
			padding: 40px 50px
			.creditRate-box {
				display: flex;
				align-items: center;
				justify-content: center;
				.creditRate {
					position: absolute
				.title {
					font-size: 13px
					font-weight: 400
					color: #A9A9A9
				}
				.rate {
					font-size: 18px;
					font-weight: bold;
					color: #333333;
				}
			}
			}
			.limit-item {
				width: 213px
				height: 120px
				font-size: 14px;
				background: #FFFFFF
				box-shadow: 0px 0px 15px 1px rgba(205, 205, 205, 0.38)
				border-radius: 10px
				margin-left: 45px
				.fx-title {
					display: flex !important
					align-items: center
					color: #333333
					margin: 15px
					.tip-icon {
						margin-left: 10px
					}
				}
				.money {
					font-size: 24px
					font-weight: bold
					color: #333333
				}
				.search-order {
					text-decoration: underline
					color: var(--fx-primary-color)
					margin-top: 8px
					cursor: pointer
				}
			}
		}
		.form-container {
			color: #333333
			font-weight: 400
			.col {
				display: flex
				align-items: center
				justify-content: start
			}
		}
		.el-form-item {
			margin-bottom: 14px;
		}
		.dialog-container {
			height: 350px
		}
		.button-box {
			padding-top: 50px;
		}
	}
	.foot {
		position: relative;
    bottom: 20px;
    height: 40px;
    margin-top: 20px;
    width: 100%;
    text-align: center;
		.btn {
			width: 103px;
			height: 35px;
			font-size: 14px;
		}
	}
}
</style>
<style lang="stylus">
	.el-dialog__header {
		text-align: left
	}
</style>
